import styled from 'styled-components';

export const RatingsContainer = styled.div`
  width: auto;
  height: 54px;
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-rows: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 5px;
  grid-auto-flow: column;
  margin-bottom: 10px;
  text-align: center;
`;

export const RatingsContainerButton = styled.div`
  cursor: pointer;
  background-color: initial;

  > p {
    color: #777777;
    font-size: 14px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0em;
    text-align: center;
  }
`;
